import script from "./ErrorBoundary.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorBoundary.vue?vue&type=script&setup=true&lang=js"

import "./ErrorBoundary.vue?vue&type=style&index=0&id=8af6cde0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8af6cde0"]])

export default __exports__